module.exports = __webpack_public_path__ + "img/67.764fb83a.jpg";